import {detect} from 'detect-browser'
var browser = detect()
var isIE = browser && browser.name == 'ie'
var isChrome = browser && browser.name == 'chrome'
var ieVersion = isIE && browser.version.split('.')[0]
import window from 'global'
var isIE9OrBelow = isIE && ieVersion <= 9

export default {
  historyApi: !!(window.history && window.history.pushState),
  tls11: !(isIE && ieVersion <= 10),
  browser: {
    name: browser.name,
    version: browser.version.split('.')[0],
  },
  input: {
    email: isIE9OrBelow ? 'text' : 'email',
    placeholder: !isIE9OrBelow,
    ignoresAutoCompleteFlag: isChrome,
  },
}
